// Lib
import { FC, memo, useEffect } from "react";
// Api
import { useGetLocationsQuery } from "rtkQuery/query/locationsAPI";
// Hooks
import { useNotification } from "hooks";
// Constants
import { rtkQueryParams } from "consts";
// Types
import { OrderReceiveMethod } from "types/orders";
// Utils
import { errorHandler } from "utils/errorHandler";
// Components
import { Select, Switch } from "components/Form";
// Styled
import { ContentBox, FlexContainer } from "styled/Box";
import { Typography } from "styled/Typography";

interface StoreProps {
  isCustomerSelected: boolean;
  locationId: string;
  orderReceiveMethod: OrderReceiveMethod;
  onLocationChange: (locationId: string) => void;
  onOrderReceiveMethodChange: (method: OrderReceiveMethod) => void;
}

const StoreComponent: FC<StoreProps> = ({
  isCustomerSelected,
  locationId,
  orderReceiveMethod,
  onLocationChange,
  onOrderReceiveMethodChange,
}) => {
  const { openNotification } = useNotification();

  const { data, isFetching, error } = useGetLocationsQuery(
    null,
    rtkQueryParams,
  );

  useEffect(() => {
    if (error) {
      errorHandler({ error, openNotification });
    }
  }, [error]);

  const locationOptions = data?.map(({ name, id }) => ({
    label: name,
    value: id,
  }));

  const selectedLocation = data?.find(({ id }) => id === locationId);

  return (
    <ContentBox $column $gap={20}>
      <Typography.H2>Store</Typography.H2>

      <Select
        disabled={!isCustomerSelected}
        loading={isFetching}
        placeholder="Select location"
        value={locationId}
        options={locationOptions}
        onChange={onLocationChange}
      />

      <FlexContainer $align="center" $gap={12}>
        <Switch
          label="Pickup order"
          formLabel
          labelPosition="left"
          checked={orderReceiveMethod === "pickup"}
          disabled={!selectedLocation?.pickupEnabled}
          onChange={checked =>
            onOrderReceiveMethodChange(checked ? "pickup" : "delivery")
          }
        />
      </FlexContainer>
    </ContentBox>
  );
};

export const Store = memo(StoreComponent);
